import "core-js/modules/es.number.constructor.js";
//@ts-ignore
import BaseFloatingLabel from "@vueEntry/UIKitComponents/BaseFloatingLabel.vue";
//@ts-ignore
import { useFloatingLabel } from "@wkComposables/UIKit/useFloatingLabel";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseTextarea",
  components: {
    BaseFloatingLabel: BaseFloatingLabel
  },
  inheritAttrs: false,
  props: {
    labelText: {
      type: String,
      "default": ""
    },
    modelValue: {
      type: [String, Number]
    },
    feedback: {
      type: Object
    },
    isValid: {
      type: Boolean,
      "default": null
    },
    textAreaStyle: {
      type: String,
      "default": ""
    },
    isDisabled: {
      type: Boolean,
      "default": false
    },
    resize: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["update:modelValue", "focusin", "focusout"],
  setup: function setup(props, context) {
    var _useFloatingLabel = useFloatingLabel(context.emit),
      labelState = _useFloatingLabel.labelState,
      setInitialLabelState = _useFloatingLabel.setInitialLabelState,
      handleFocusIn = _useFloatingLabel.handleFocusIn,
      handleFocusOut = _useFloatingLabel.handleFocusOut;
    return {
      labelState: labelState,
      setInitialLabelState: setInitialLabelState,
      handleFocusIn: handleFocusIn,
      handleFocusOut: handleFocusOut
    };
  },
  data: function data() {
    return {
      //This inner value is useful in case the inner value of the textarea do not match with the modelValue
      value: ""
    };
  },
  computed: {
    textareaElem: function textareaElem() {
      return this.$refs.textarea;
    }
  },
  watch: {
    modelValue: function modelValue(cur, prev) {
      if ("".concat(cur).length > 0 && this.labelState !== "floating-label")
        //@ts-ignore
        this.labelState = "floating-label";
    }
  },
  created: function created() {
    this.setInitialLabelState(this.modelValue);
  },
  methods: {
    handleOnChange: function handleOnChange(_ref) {
      var target = _ref.target;
      this.value = target.value;
      this.$emit("update:modelValue", target.value);
    },
    handleFloatingLabelClick: function handleFloatingLabelClick() {
      this.$refs.textarea.focus(); //Focusing the input!
    },
    /* Favorite scenario: multiple baseTextarea */disableTextarea: function disableTextarea() {
      this.textareaElem.setAttribute("readonly", "readonly");
      this.textareaElem.classList.add("disabled");
    },
    clearTextareaElem: function clearTextareaElem() {
      this.textareaElem.value = "";
      console.log(this.textareaElem.value);
    },
    disableAndFocusTextarea: function disableAndFocusTextarea() {
      var _this = this;
      this.textareaElem.removeAttribute("readonly");
      this.textareaElem.classList.remove("disabled");
      //Ensuring that the disabled attribute has been removed
      this.$nextTick(function () {
        _this.textareaElem.focus();
      });
    }
  }
});